import { useMemo } from 'react';
import { getProfileGroups, getCognitoGroups, getProfileFromToken } from './headerProfileGroups';
import {
  getDomesticNavAccess,
  getDomesticHeaderSubNavState,
  buildIntlBookingSubLinks,
  buildDomBookingSubLinks,
  buildIntlShipmentSubLinks,
  buildDomShipmentSubLinks,
  buildIntlShippingInstructionSubLinks,
  buildDomShippingInstructionSubLinks,
  buildIntlDocumentSubLinks,
  buildDomDocumentSubLinks,
  buildDomAccountStatementSubLinks,
} from './domesticNavPermissions';
import domesticStyles from './HeaderDomestic.module.css';

export function useDomesticHeaderState({ user, assumeuser, location }) {
  const pathname = (location && location.pathname) || '';

  const grps = useMemo(
    () => getProfileGroups(user, assumeuser),
    [user, assumeuser]
  );

  const profile = useMemo(() => getProfileFromToken(user), [user]);

  const access = useMemo(
    () => getDomesticNavAccess(grps, user),
    [grps, user]
  );

  const subNav = useMemo(
    () => getDomesticHeaderSubNavState(pathname, access),
    [pathname, access]
  );

  const cognitoGroups = useMemo(() => getCognitoGroups(user), [user]);

  const subLinks = useMemo(
    () => ({
      intlBooking: buildIntlBookingSubLinks(access, pathname),
      domBooking: buildDomBookingSubLinks(access, pathname, location),
      intlShipment: buildIntlShipmentSubLinks(access, pathname),
      domShipment: buildDomShipmentSubLinks(access, pathname),
      intlShippingInstruction: buildIntlShippingInstructionSubLinks(
        access,
        pathname
      ),
      domShippingInstruction: buildDomShippingInstructionSubLinks(
        access,
        pathname
      ),
      intlDocument: buildIntlDocumentSubLinks(access, pathname),
      domDocument: buildDomDocumentSubLinks(access, pathname),
      domAccountStatement: buildDomAccountStatementSubLinks(access, pathname),
    }),
    [access, pathname, location]
  );

  const spacerClass = useMemo(() => {
    const hasLegacyTitle = Boolean(subNav.legacyPageTitleKey);
    const heightClass = subNav.showDomesticSub
      ? hasLegacyTitle
        ? domesticStyles.spacerHeightWithSubAndTitle
        : domesticStyles.spacerHeightWithSub
      : hasLegacyTitle
      ? domesticStyles.spacerHeightMainAndTitle
      : domesticStyles.spacerHeightMain;
    return [
      domesticStyles.spacer,
      heightClass,
      subNav.pageHasLegacyHeaderOffset
        ? domesticStyles.spacerCancelLegacyOffset
        : '',
    ]
      .filter(Boolean)
      .join(' ');
  }, [
    subNav.showDomesticSub,
    subNav.pageHasLegacyHeaderOffset,
    subNav.legacyPageTitleKey,
  ]);

  const subLinkClass = (active) =>
    [domesticStyles.subLink, active ? domesticStyles.subLinkActive : ''].join(
      ' '
    );

  return {
    grps,
    profile,
    access,
    subNav,
    cognitoGroups,
    subLinks,
    spacerClass,
    subLinkClass,
    pathname,
  };
}
